import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";


const gamesSwiper = new Swiper("#games-container", {
  spaceBetween: 45,
  slidesPerView: 3,
  centeredSlides: false,
  modules: [Navigation],
  loop: false,
  initialSlide: 1,
  arrow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1400: {
      slidesPerView: 3,
      spaceBetween: 45,
    },
    601: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    600: {
      slidesPerView: 1.05,
      spaceBetween: 16,
      centeredSlides: true,
    },
    320: {
      slidesPerView: 1.1,
      spaceBetween: 16,
      centeredSlides: true,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
    },
  }
});


